import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle, CheckCircle2, Clock } from "lucide-react";
import { SecretValue } from "@/components/SecretValue";

const ST = { APPROVED: "text-emerald-300", PENDING: "text-amber-300", REJECTED: "text-red-300" };

export const WhatsAppSettings = ({ s, setS }) => {
  const [tpls, setTpls] = useState(null);
  const [busy, setBusy] = useState(false);
  const loadTpls = () => api.get("/whatsapp/templates").then((r) => setTpls(r.data)).catch(() => setTpls([]));
  useEffect(() => { if (s.wa_configured) loadTpls(); }, [s.wa_configured]);
  const create = async () => {
    setBusy(true);
    try { const { data } = await api.post("/whatsapp/templates"); setTpls(data.templates); toast.success("Modelos enviados para aprovação da Meta"); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao criar modelos"); }
    setBusy(false);
  };
  const toggle = async (v) => {
    await api.put("/settings", { wa_auto_enabled: v }); setS({ ...s, wa_auto_enabled: v });
    toast.success(v ? "WhatsApp ligado na régua diária" : "WhatsApp desligado da régua");
  };
  return (
    <div data-testid="settings-whatsapp" className="bg-[#111827] border border-[#1F293D] rounded-xl p-5 mb-5">
      <h3 className="text-base font-semibold text-slate-200 flex items-center gap-2 mb-4"><MessageCircle className="h-5 w-5 text-[#25D366]" /> WhatsApp oficial · Meta Cloud API</h3>
      {s.wa_configured ? (
        <div data-testid="wa-status" className="flex items-center gap-2 mb-3 text-sm text-emerald-300 bg-emerald-500/10 border border-emerald-500/20 rounded-lg px-3 py-2">
          <CheckCircle2 className="h-4 w-4" /> Conectado à API oficial da Meta.
        </div>
      ) : (
        <div data-testid="wa-status" className="flex items-center gap-2 mb-3 text-sm text-amber-300 bg-amber-500/10 border border-amber-500/20 rounded-lg px-3 py-2">
          <Clock className="h-4 w-4" /> Aguardando credenciais: Phone Number ID, WABA ID, token do usuário do sistema e App Secret.
        </div>
      )}
      {s.wa_configured && (
        <>
          <div className="mb-3 space-y-1.5">
            {(tpls || []).map((t) => (
              <div key={t.name} data-testid={`wa-template-${t.name}`} className="flex justify-between rounded-lg border border-[#1F293D] bg-[#0F141F] px-3 py-2 text-xs">
                <span className="font-mono text-slate-300">{t.name}</span><span className={ST[t.status] || "text-slate-400"}>{t.status}</span>
              </div>
            ))}
            {tpls && tpls.length < 2 && (
              <button data-testid="wa-create-templates" disabled={busy} onClick={create} className="rounded-lg bg-[#25D366] px-3 py-1.5 text-xs font-semibold text-slate-950 disabled:opacity-50">Criar modelos de cobrança na Meta</button>
            )}
          </div>
          <label data-testid="settings-wa-auto" className="flex items-center justify-between gap-3 rounded-lg border border-[#1F293D] bg-[#0F141F] px-3 py-2.5 cursor-pointer">
            <span className="text-sm text-slate-300">WhatsApp na régua diária (junto com o SMS)
              <span className="block text-xs text-slate-500">{s.wa_auto_enabled ? "Ligado: cada regra envia WhatsApp e SMS." : "Desligado: WhatsApp só pelo botão na ficha do cliente."}</span>
            </span>
            <input data-testid="settings-wa-auto-toggle" type="checkbox" className="h-5 w-5 accent-emerald-500" checked={!!s.wa_auto_enabled} onChange={(e) => toggle(e.target.checked)} />
          </label>
        </>
      )}
      <div className="mt-3">
        <label className="text-xs text-slate-400">Mensagem inicial do Suporte (botão "Chamar no WhatsApp Web") · use {"{primeiro_nome}"}</label>
        <textarea data-testid="settings-wa-greeting" rows={2} defaultValue={s.wa_support_greeting}
          onBlur={async (e) => { await api.put("/settings", { wa_support_greeting: e.target.value }); setS({ ...s, wa_support_greeting: e.target.value }); toast.success("Mensagem do Suporte salva"); }}
          className="mt-1 w-full rounded-lg border border-[#1F293D] bg-[#0F141F] px-3 py-2 text-sm text-white" />
      </div>
      <div className="mt-3 text-xs text-slate-400">
        Webhook na Meta (App → WhatsApp → Configuração), campo <b>messages</b>:
        <div data-testid="settings-wa-webhook" className="mt-1 font-mono text-sky-300 break-all">{process.env.REACT_APP_BACKEND_URL}{s.wa_webhook_url}</div>
        <div className="mt-1">Verify token: <SecretValue testid="settings-wa-verify" masked={s.wa_verify_token} field="wa_verify_token" /></div>
      </div>
    </div>
  );
};
